import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant13() {
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [step, setStep] = useState(0);
  useEffect(() => {
    const timer1 = setTimeout(() => setStep(1), 1000);
    const timer2 = setTimeout(() => setStep(2), 2500);
    const timer3 = setTimeout(() => setStep(3), 4000);
    const timer4 = setTimeout(() => setStep(4), 5500);
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      clearTimeout(timer4);
    };
  }, []);
  return <>
      <section className="relative min-h-screen w-full overflow-hidden pt-32 pb-20 flex items-center" style={{
      backgroundColor: 'var(--bg-primary)'
    }} data-id="element-402">
        <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col lg:flex-row items-center justify-between gap-12 px-4" data-id="element-403">
          <div className="w-full lg:w-1/2 text-left flex flex-col items-start" data-id="element-404">
            <h1 className="mb-6 text-4xl md:text-5xl lg:text-[3.5rem] font-bold leading-tight text-gray-900" data-id="element-405">
              Сайт{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-406">
                БЕСПЛАТНО.
              </span>
              <br data-id="element-407" />
              Платишь только {price}/мес.
            </h1>
            <p className="text-lg md:text-xl mb-8 text-gray-600 font-medium" data-id="element-408">
              Сначала макет — потом решение. Не понравится — уходишь без оплаты.
            </p>
            <button onClick={() => setIsPopupOpen(true)} className="group relative flex items-center justify-center gap-2 rounded-2xl px-8 py-4 font-bold text-lg transition-all hover:scale-105 overflow-hidden w-full sm:w-auto" style={{
            backgroundColor: 'var(--accent)',
            color: '#FFFFFF'
          }} data-id="element-409">
              Получить бесплатный макет
              <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-410" />
            </button>
          </div>

          {/* Right Column - Chat Simulation */}
          <div className="w-full lg:w-1/2 relative mt-12 lg:mt-0 flex justify-center" data-id="element-411">
            <div className="w-full max-w-md bg-gray-50 rounded-3xl p-6 shadow-2xl border border-gray-200 h-[400px] flex flex-col justify-end" data-id="element-412">
              <div className="space-y-4 overflow-hidden" data-id="element-413">
                {step >= 1 && <motion.div initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} className="flex justify-end" data-id="element-414">
                    <div className="bg-blue-500 text-white rounded-2xl rounded-tr-sm px-4 py-2 max-w-[80%] shadow-sm" data-id="element-415">
                      Здравствуйте! Сколько стоит сделать сайт для моего
                      бизнеса?
                    </div>
                  </motion.div>}

                {step >= 2 && <motion.div initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} className="flex justify-start" data-id="element-416">
                    <div className="bg-white text-gray-800 rounded-2xl rounded-tl-sm px-4 py-2 max-w-[80%] shadow-sm border border-gray-100" data-id="element-417">
                      Добрый день! Разработка — 0$. Вы платите только {price}
                      /мес за хостинг и поддержку.
                    </div>
                  </motion.div>}

                {step >= 3 && <motion.div initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} className="flex justify-end" data-id="element-418">
                    <div className="bg-blue-500 text-white rounded-2xl rounded-tr-sm px-4 py-2 max-w-[80%] shadow-sm" data-id="element-419">
                      А если мне не понравится дизайн?
                    </div>
                  </motion.div>}

                {step >= 4 && <motion.div initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} className="flex justify-start" data-id="element-420">
                    <div className="bg-white text-gray-800 rounded-2xl rounded-tl-sm px-4 py-2 max-w-[80%] shadow-sm border border-gray-100" data-id="element-421">
                      Тогда вы ничего не платите 🤝 Мы делаем макет бесплатно,
                      оплата только если вас всё устроит.
                    </div>
                  </motion.div>}
              </div>
            </div>
          </div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-422" />
    </>;
}